import { Link } from "react-router-dom";

const IMG_HERO = "https://images.unsplash.com/photo-1750064139819-da3bf362e7b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxzaWxrJTIwcm9iZSUyMHNsZWVwd2VhcnxlbnwwfHx8fDE3ODMwODExNTZ8MA&ixlib=rb-4.1.0&q=85";
const IMG_ATELIER = "https://images.unsplash.com/photo-1634241796701-24569ef1c554?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBsaW5nZXJpZSUyMGZhc2hpb258ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative min-h-[70vh] overflow-hidden">
        <img src={IMG_HERO} alt="Iamravishing atelier" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1A1A1A]/20 to-[#1A1A1A]/60" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 pt-40 pb-24 min-h-[70vh] flex flex-col justify-end">
          <div className="overline text-[#D9C5B2] mb-6">Est. 2026 · Paris & Mumbai</div>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-[#FAF8F5] leading-[0.95] tracking-tighter max-w-3xl">
            A private<br/><em className="text-[#D9C5B2] font-light">house.</em>
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-24 lg:py-32">
        <div className="overline text-[#4A1525] mb-6">Our story</div>
        <p className="font-serif text-3xl md:text-4xl leading-tight mb-12 text-[#1A1A1A]">
          Iamravishing was born from a single conviction: that the pieces a woman wears beneath everything else are the ones that speak loudest to her.
        </p>
        <div className="space-y-8 text-[#5C5C5C] leading-relaxed text-lg">
          <p>Founded in 2026 by a small collective of designers with roots in French couture houses and Indian embroidery ateliers, our house exists at the intersection of two traditions — the precision of Parisian tailoring and the poetry of hand-craft.</p>
          <p>Every piece is cut in limited runs, from mulberry silk woven in Karnataka, Chantilly lace milled in Calais, and ethically sourced Italian stretch. Nothing is ever made in quantities that would compromise the touch of the hands that make it.</p>
          <p>We believe intimate apparel should not be an afterthought. It should be a ritual — the private, elegant gesture of dressing first for oneself. Ravishing, always, and always for her.</p>
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-2 gap-8">
        <img src={IMG_ATELIER} alt="Atelier" className="w-full aspect-[4/5] object-cover" />
        <div className="flex flex-col justify-center p-6 md:p-12">
          <div className="overline text-[#4A1525] mb-6">Values</div>
          <h2 className="font-serif text-4xl md:text-5xl mb-8 leading-tight">Slow. Considered. Never generic.</h2>
          <ul className="space-y-6 text-[#5C5C5C] leading-relaxed">
            <li><span className="overline text-[#1A1A1A] block mb-1">Ethical sourcing</span>Every material traced to its origin. No exceptions.</li>
            <li><span className="overline text-[#1A1A1A] block mb-1">Hand-finished</span>Each piece passes through the hands of one seamstress from cut to closure.</li>
            <li><span className="overline text-[#1A1A1A] block mb-1">Limited runs</span>We produce no more than we can pack ourselves.</li>
            <li><span className="overline text-[#1A1A1A] block mb-1">Discreet always</span>Unmarked packaging, whispered delivery.</li>
          </ul>
        </div>
      </section>

      <section className="text-center py-24 px-6">
        <Link to="/shop" className="bg-[#4A1525] text-[#FAF8F5] px-10 py-5 overline hover:bg-[#360F1B] transition-colors" data-testid="about-shop-cta">
          Discover the collection
        </Link>
      </section>
    </div>
  );
}
